/**
 * Star Rating.jsx
 * Created by Destin Frasier on 8/3/17.
 * Modifieid by Mike Bray on 8/11/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import * as Icons from './icons/Icons';
import { FlexRow } from '../sharedComponents/FlexGrid';

const propTypes = {
    rating: PropTypes.number,
    size: PropTypes.string,
    voteCount: PropTypes.number,
    format: PropTypes.string
};

const defaultProps = {
    rating: 0,
    voteCount: 0,
    size: 'md'
};

export default class StarRating extends React.Component {
    getVoteCountText = () => {
        if (!this.props.voteCount) {
            return '';
        }
        if (this.props.format === 'fmt2') {
            return `(${this.props.voteCount})`;
        }
        return `(${this.props.voteCount})`;
    };

    _generateStars() {
        let rating = this.props.rating;
        let key = 0;
        const stars = [];

        while (rating > 0 && stars.length < 5) {
            if (rating >= 1) {
                stars.push(<Icons.IconStar key={`star-rating-${key}`} size={this.props.size} />);
            }
            else {
                stars.push(<Icons.IconStarHalf key={`star-rating-${key}`} size={this.props.size} />);
            }

            rating -= 1;
            key += 1;
        }

        while (stars.length < 5) {
            stars.push(<Icons.IconStarBorder key={`star-rating-${key}`} size={this.props.size} />);
            key += 1;
        }

        return stars;
    }

    renderBody = (sanitisedRating, starText, voteCountText) => {
        const voteCount = get(this.props, 'voteCount', 0);
        const stars = this._generateStars();
        if (this.props.format === 'fmt2') {
            return (
                <FlexRow alignItems="center" className="recommendation-card--star-line">
                    <span
                        className="rec-stars-container recommendation-card--star-rating"
                        aria-label={`${sanitisedRating} ${starText}, ${voteCountText}`}>
                        {stars}
                    </span>
                    {voteCount > 0 &&
                    <span className="recommendation-card--star-count" aria-hidden="true">
                        {voteCountText}
                    </span>
                    }
                </FlexRow>
            );
        }
        return (
            <div>
                <div className="rec-stars-container" aria-hidden="true" >
                    {stars}
                    <span className="vote-count" aria-hidden="true">
                        {voteCountText}
                    </span>
                </div>
            </div>
        );
    };

    render() {
        let sanitisedRating = this.props.rating < 0 ? 0 : this.props.rating;
        sanitisedRating = sanitisedRating > 5 ? 5 : sanitisedRating;

        let starText = 'stars';
        if (sanitisedRating === 1) {
            starText = 'star';
        }

        const voteCountText = this.getVoteCountText();

        return (
            <div
                className="rec-star-rating"
                aria-label={`${sanitisedRating} ${starText}, ${voteCountText}`} >
                {this.renderBody(sanitisedRating, starText, voteCountText)}
            </div>
        );
    }
}

StarRating.propTypes = propTypes;
StarRating.defaultProps = defaultProps;
